export default "/images/93a71fcd56b688e112c1e308fe64a03e.avif";